import { Col, Row } from "antd";
import Card from "common/display/Card";
import FilledButton from "common/Form/Button";
import Layout from "common/Layout";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authorizedRequest } from "api";

export default function Reviewer({ ...props }) {
  const navigate = useNavigate();
  const [nFiles, setNFiles] = useState(0);
  const [nTenders, setNTenders] = useState(0);

  useEffect(() => {
    authorizedRequest(`self_files`, {
      method: "GET",
    })
      .then((success) => !!success.files && setNFiles(success.files.length))
      .catch((error) => console.error(error));

    authorizedRequest(`tenders`, {
      method: "GET",
    })
      .then(
        (success) => !!success.tenders && setNTenders(success.tenders.length)
      )
      .catch((error) => console.error(error));
  }, []);

  return (
    <Layout
      headerLeftButton={{ content: "Mis proyectos", onClick: () => {} }}
      headerRightButton={{ content: "¿Cómo funciona?", onClick: () => {} }}
    >
      <Row style={{ height: "50%" }}>
        <Col xs={24}>
          <h1 className="text-center" style={{ marginBottom: 0 }}>
            Hola
          </h1>
          <h2 className="text-center">¿Qué quieres hacer?</h2>

          <Row justify="end" gutter={48} style={{ alignSelf: "bottom" }}>
            <Col lg="auto">
              <FilledButton to={"/reviewer/validate"}>
                Validar modelo
              </FilledButton>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row justify="space-between" align="bottom" style={{ height: "50%" }}>
        <Col lg={10}>
          <Card
            title={nTenders + " Proyecto(s) disponible(s)"}
            actionTitle={"Ver detalles"}
            action={() => navigate("/reviewer/tenders")}
          />
        </Col>
        <Col lg={10}>
          <Card
            green
            title={nFiles + " Archivo(s) subido(s)"}
            actionTitle={"Ver detalles"}
            action={() => navigate("/reviewer/validate")}
          />
        </Col>
      </Row>
    </Layout>
  );
}
